import React, { PureComponent } from "react";

import Slide from "./Slide";
import { connect } from "react-redux";
import styles from "./Dashboard.local.scss";

class Dashboard extends PureComponent {
  render() {
    const {
      data: { slides, extraInfos },
      currentOrganization
    } = this.props;

    return (
      <div className={styles.content}>
        {slides.map((slide, i) => {
          return (
            <Slide
              key={i}
              slide={slide}
              isResponsive={true}
              isEmbedded={slide.isEmbedded}
              handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
              comments={this.props.comments}
              extraInfos={extraInfos}
              dashboardPage={true}
              currentOrganization={currentOrganization}
            />
          );
        })}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  comments: state.preparePresentation.items.comments,
  currentOrganization: state.auth.currentOrganization
});

export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js